import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ListCellDefDirective,
  ListModuleColumnDef,
  ListModuleTableComponent,
} from 'src/app/shared/components/list-module';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { AppDatePipe } from 'src/app/shared/pipes/app-date.pipe';
import { HasPermissionPipe } from 'src/app/core/pipes/has-permission.pipe';
import { SUPER_ADMIN_PERMISSION_SLUGS } from 'src/app/core/constants/super-admin-permission-slugs';

export interface ActivityRow {
  srNo: number;
  sessionId: number;
  sessionCode: string | null;
  sessionSource: 'platform' | 'tenant';
  customerName: string;
  agentName: string;
  description: string;
  status: string;
  tenantId: number | null;
  created_at: string;
}

@Component({
  selector: 'app-activities-table',
  standalone: true,
  imports: [
    CommonModule,
    IconModule,
    AppDatePipe,
    ListModuleTableComponent,
    ListCellDefDirective,
    HasPermissionPipe,
  ],
  templateUrl: './activities-table.component.html',
})
export class ActivitiesTableComponent {
  readonly P = SUPER_ADMIN_PERMISSION_SLUGS;

  @Input() rows: ActivityRow[] = [];
  @Input() loading = false;
  @Input() emptyMessage = 'No activities match your filters.';

  @Output() view = new EventEmitter<ActivityRow>();

  get columns(): ListModuleColumnDef[] {
    return [
      { id: 'serial', header: '#', cellClass: 'whitespace-nowrap text-gray-500' },
      { id: 'customer', header: 'Customer', cellClass: 'font-semibold' },
      { id: 'agent', header: 'Agent' },
      { id: 'activity', header: 'Activity' },
      { id: 'status', header: 'Status', align: 'center', cellClass: 'whitespace-nowrap text-center' },
      { id: 'date', header: 'Date', cellClass: 'whitespace-nowrap text-sm text-gray-500' },
      { id: 'actions', header: 'Action', align: 'right', cellClass: 'text-end' },
    ];
  }

  statusBadgeClass(status: string): string {
    const base = 'inline-flex items-center rounded-full py-1 px-3 text-xs font-semibold';
    const map: Record<string, string> = {
      Approved: 'text-success bg-success-light',
      Completed: 'text-success bg-success-light',
      'Under Review': 'text-warning bg-warning-light',
      'KYC Done': 'text-warning bg-warning-light',
      'Interview Done': 'text-primary bg-primary-light',
      Rejected: 'text-danger bg-danger-light',
      Failed: 'text-danger bg-danger-light',
    };
    return `${base} ${map[status] ?? 'text-gray-600 bg-gray-100 dark:text-gray-300 dark:bg-white/10'}`;
  }
}
